export default class anchor {
  constructor(opt = {}) {
    this.media = opt.media;
  }
  init(){
    this.smoothScroll();
    this.linkScroll();
  }
  //ページ内アンカーリンク
  smoothScroll(){
    const headerHeight = this.media === 'pc'? 83 : 60;
    $('a[href^="#"]').not('.is-no_anchor, .js-print').click(function() {
      let speed = 1000;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top - headerHeight;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
  }
  //別ページからのアンカーリンク
  linkScroll(){
    const headerHeight = this.media === 'pc'? 83 : 60;
    let url = $(location).attr('href');
    if(url.indexOf("?id=") != -1){
     let speed = 1000;
     let id = url.split("?id=");
     let $target = $('#' + id[id.length - 1]);
      if($target.length){
       let pos = $target.offset().top - headerHeight;
       $("html, body").animate({scrollTop:pos}, speed, "swing");
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/anchor.js